import { Box, Button, ButtonBase, Grid, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useEffect, useState } from "react";
import { Integration } from "Models/integration";
import { IntegrationType } from "Models/integration-type";
import { useGetIntegrationsQuery, useSyncMutation } from "Services/company";
import { useGetMeQuery } from "Services/user";
import { useAppSelector } from "State/hooks";
import { configManager } from "Helpers/config-manager";

const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
});
export default function Integrations() {
    const config = configManager.getConfig();
    const companyId = useAppSelector((state) => state.company.companyId);
    const [enableHubspot, setEnableHubspot] = useState(false);
    const [syncClicked, setSyncClicked] = useState(false);
    const [integrations, setIntegrations] = useState<Array<Integration>>([]);
    const { data: integrationData } = useGetIntegrationsQuery(companyId, { skip: !companyId });
    const [syncMutation] = useSyncMutation();
    const { data: me } = useGetMeQuery();

    useEffect(() => {
        if (integrationData) {
            if (integrationData.length > 0) {
                setIntegrations(integrationData);
                const hubSpot = integrationData.find((int: Integration) => int.type === IntegrationType.hs);
                if (!hubSpot) {
                    setEnableHubspot(true);
                }
            } else {
                setEnableHubspot(true);
            }
        }
    }, [integrationData])

    const integrateWithHubSpot = () => {
        if (!config?.hubspot.clientId || !config.hubspot.scopes || !config.hubspot.redirectUri) {
            return;
        };

        let scopes = '';

        if (config.hubspot.scopes) {
            scopes = (config.hubspot.scopes.split(/ |, ?|%20/)).join(' ');
        }

        const authUrl =
            `${config.hubspot.baseAuthUrl}` +
            `?client_id=${encodeURIComponent(config?.hubspot.clientId)}` + // app's client ID
            `&scope=${encodeURIComponent(scopes)}` + // scopes being requested by the app
            `&redirect_uri=${encodeURIComponent(config.hubspot.redirectUri)}`; // where to send the user after the consent page

        window.location.href = authUrl;
    }

    const synchronize = async () => {
        setSyncClicked(true);
        syncMutation({ companyId: companyId, userEmail: me?.email });
    }

    return <>
        <Box display="flex" flex="1" flexDirection="row" margin="20px" justifyContent="center" alignItems="center" minHeight="80vh">
            <Paper
                sx={{
                    display: "flex",
                    p: 2,
                    maxWidth: 500,
                    flexGrow: 1,
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
                }}
            >
                <Grid container spacing={2}>
                    <Grid item>
                        <ButtonBase sx={{ width: 128, height: 128 }}>
                            <Img alt="complex" src="/hubspot.svg" />
                        </ButtonBase>
                    </Grid>
                    <Grid item xs={12} sm container>
                        <Grid item xs container direction="column" spacing={2}>
                            <Grid item xs>
                                <Typography gutterBottom variant="subtitle1" component="div">
                                    Integrate with Hubspot
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                    Streamline your marketing and sales efforts by seamlessly integrating with HubSpot, a powerful platform that empowers you to attract, engage, and delight customers with ease.
                                </Typography>
                            </Grid>
                            <Grid item className="flex justify-between">
                                <Button variant="contained" disabled={!enableHubspot} onClick={integrateWithHubSpot}>Integrate with HubSpot</Button>
                                {!enableHubspot && <Button variant="contained" disabled={syncClicked} onClick={synchronize}>Sync</Button>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </Box>

    </>
}